import { PolicyType } from "@lib";
import { PAYMENT_KEYS } from "@lib/utilities/Constants";
import { unwrapDecimal } from "../policyScreen/policyParser";

export interface BillingDetails {
  noticeAmountDue: number;
  invoiceDueDate: string;
  currentPremium: string;
  initialPremium: string;
  balance: string;
  billPlan: string;
  billToType: string;
  billToId: string;
}

export interface Payments {
  date: "";
  amount: "";
  type: "";
  description: "";
}

export const getPolicyholderNameHelper = (
  policyData: { policies: PolicyType[]; selectedPolicyNumber: string },
  billingDetails: BillingDetails,
): string => {
  if (!policyData.selectedPolicyNumber || !billingDetails.billToId) return "";

  const policyList = policyData.policies;
  const selectedPolicy = policyList?.find(
    (item: PolicyType) => item.policyNumber === policyData.selectedPolicyNumber,
  );

  if (selectedPolicy && billingDetails.billToType === "Policyholder") {
    const policyHolder = selectedPolicy.policyHolders.find(
      (item: any) => item._id === billingDetails.billToId,
    );
    return policyHolder
      ? `Policyholder: ${policyHolder.firstName} ${policyHolder.lastName}`
      : "";
  }

  const additionalInterest = selectedPolicy?.additionalInterests.find(
    (item: any) => item._id === billingDetails.billToId,
  );

  return additionalInterest
    ? `${additionalInterest.type}: ${additionalInterest.name1} ${additionalInterest.name2}`
    : "";
};

export const toBillingPaymentModal = (billingPayment: any) => ({
  noticeAmountDue: billingPayment.noticeAmountDue,
  invoiceDueDate: billingPayment.invoiceDueDate,
  currentPremium: billingPayment.currentPremium,
  initialPremium: billingPayment.initialPremium,
  balance: billingPayment.balance,
  billPlan: billingPayment.billPlan,
  billToType: billingPayment.billToType,
  billToId: billingPayment.billToId,
});

export const toPreviousPaymentModal = (payment: any) => ({
  date: payment.date?.["$date"] ?? payment.date,
  amount: unwrapDecimal(payment.amount),
  type: payment.type,
  description: payment.description,
});

export const toPreviousPaymentsModal = (previousPayments: any) =>
  previousPayments.map((payment: any) => toPreviousPaymentModal(payment));

export const toPaymentSession = (payment: any) => ({
  sessionId: payment.sessionId,
  ...payment.sessionData,
});

export const toOneIncPaymentSession = (
  session: any,
  payableAmount: number,
) => ({
  sessionId: session.sessionId,
  userRole: PAYMENT_KEYS.userRole,
  paymentCategory: PAYMENT_KEYS.paymentCategory,
  feeContext: PAYMENT_KEYS.feeContext,
  amountContext: PAYMENT_KEYS.amountContext,
  billingZip: session.billingZipCode,
  minAmountDue: Number(payableAmount),
  accountBalance: session.accountBalance,
  policyHolderName: session.policyHolderName,
  accountGroupCode: session.accountGroupCode,
  clientReferenceData1: session.clientReferenceData1,
  clientReferenceData2: PAYMENT_KEYS.clientReferenceData2,
  clientReferenceData3: session.clientReferenceData3,
  clientReferenceData4: session.clientReferenceData4,
  clientReferenceData5: session.clientReferenceData5,
  email: session.email.toLowerCase(),
  extendedParameters: {
    originPaymentPortal: PAYMENT_KEYS.sourceName,
    processorUsername: session.paymentUsername,
  },
  customerId: session.customerId,
});
